<!--
 * @Name: editUser.vue
 * @Description: 添加/修改用户信息
 * @Author: xiadongxue
 * @Date: 2021-10-21 11:25:21
 * @Editors: xiadongxue
-->
<template>
<div class="user-edit-wrap">
    <el-dialog
        v-loading="loading"
        title="用户信息"
        :visible.sync="visible"
        :modal-append-to-body="false"
        @close="close"
        width="600px">
        <el-form
            label-width="170px"
            ref="form"
            :model="form"
            :rules="userRules">
            <el-form-item
                prop="email"
                label="邮箱">
                <el-input
                    v-model="form.email"
                    size="small">
                    <template slot="append">
                        <el-select v-model="emailSuffix">
                            <el-option v-for="item in emailList" :key="item.emailSuffix" :value="item.emailSuffix" :label="item.emailSuffix"></el-option>
                        </el-select>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item
                prop="userName"
                label="用户昵称">
                <el-input
                    v-model="form.userName"
                    size="small" />
            </el-form-item>
            <el-form-item
                prop="phone"
                label="手机号">
                <el-input
                    placeholder="海外账号请以（+区号）开头"
                    v-model="form.phone"
                    size="small" />
            </el-form-item>
            <el-form-item
                prop="workType"
                label="工种">
                <el-select
                    size="small"
                    placeholder="请为用户分配工种"
                    v-model="form.workType">
                    <el-option
                        v-for="item in workTypeList"
                        :key="item.id"
                        :value="item.id"
                        :label="item.label" />
                </el-select>
            </el-form-item>
            <el-form-item
                prop="reporter"
                label="审核人">
                <el-select
                    filterable
                    remote
                    :remote-method="toGetUser"
                    @focus="toGetUser()"
                    size="small"
                    placeholder="输入邮箱/昵称/用户id 可进行查询"
                    v-model="form.reporter">
                    <el-option
                        v-for="item in userList"
                        :key="item.userName"
                        :value="item.userName"
                        :label="item.userName" />
                </el-select>
            </el-form-item>
            <el-form-item
                prop="workMark"
                label="职位">
                <el-select
                    size="small"
                    placeholder="请选择职位"
                    v-model="form.workMark">
                    <el-option
                        v-for="item in workMarkList"
                        :key="item.id"
                        :value="item.id"
                        :label="item.label" />
                </el-select>
            </el-form-item>
            <el-form-item
                prop="note"
                label="备注">
                <el-input
                    v-model="form.note"
                    size="small"
                    type="textarea" />
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="visible = false"
                size="small">取消</el-button>
            <el-button
                size="small"
                type="danger"
                @click="toSubmit">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {
    addUser,
    editUser,
    emailList,
    getWorkType,
    getUserList
} from '../api'
export default {
    name: 'editUser',
    props: {
        //表单信息
        data: {
            type: Object,
            default: () => ({})
        },
        //弹窗展示
        show: {
            type: Boolean,
            default: false
        },
        //是否为添加
        add: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.form = Object.assign({},this.data)
        this.visible = this.show
        this.toGetEmail()
        //工种
        this.toGetWorkType()
        //上级
        this.toGetUser()
    },
    data() {
        return {
            loading: false,
            //data
            form: {},
            //rules
            userRules: {
                userName: [{
                    required: true,
                    message: "请输入",
                    trigger: 'change'
                }],
                email: [{
                    required: true,
                    message: "请输入",
                    trigger: 'change'
                }, {
                    pattern: /^[a-z0-9.-]+$/i,
                    message: '只能输入大小写字母与数字'
                }],
                reporter: [{
                    required: true,
                    message: "请选择",
                    trigger: 'change'
                }]
            },
            visible: true,
            emailList: [],
            emailSuffix: '@taiyouxi.cn',
            //工种列表
            workTypeList: [],
            //汇报人
            userList: [],
            //职位列表
            workMarkList: [{
                id: 1,
                label: 'Leader'
            },{
                id: 2,
                label: '审核人'
            },{
                id: 3,
                label: '职员'
            }]
        }
    },
    methods: {
        //点击确定
        toSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    //通过校验
                    this.toSave();
                } else {
                    return false;
                }
            });
        },
        //保存
        async toSave() {
            try {
                this.loading = true
                let Fn = addUser
                let data = {
                    userName: this.form.userName,
                    email: this.form.email + this.emailSuffix,
                    phone: this.form.phone,
                    note: this.form.note,
                    workType: this.form.workType,
                    reporter: this.form.reporter,
                    workMark: this.form.workMark
                }
                if (!this.add) {
                    Fn = editUser
                    data.userId = this.form.userId
                }
                let {
                    code
                } = await Fn(data)
                if (code === 0) {
                    this.$message.success(`${this.add ? '添加' : '修改'}成功`)
                    this.visible = false
                    if (this.add) {
                        this.form = this.data;
                    }
                    this.$emit('submit')
                }
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        //移除表单项校验结果
        close() {
            this.$emit('update:show', false)
            if(this.add) {
                this.form = {}
            } else {
               this.initData(this.data) 
            }
            this.emailSuffix = '@taiyouxi.cn'
            this.$nextTick(this.$refs['form'].clearValidate)
        },
        //获取邮箱后缀
        async toGetEmail() {
            let {
                code,
                result
            } = await emailList({
                enabled: 1
            })
            if (code === 0) {
                this.emailList = result
            }
        },
        //数据初始化
        initData(newVal) {
            newVal = Object.assign({},newVal)
            let emailArr = newVal.email.split('@')
            newVal.email = emailArr[0]
            this.emailSuffix = '@' + emailArr[1]
            this.form = newVal
        },
        //工种查询
        async toGetWorkType() {
            try {
                let {code,result} = await getWorkType()
                if(code === 0) {
                    this.workTypeList = result
                }
            } catch (error) {
                console.log(error)
            }
        },
        //获取汇报人
        async toGetUser(query) {
             try {
                let { code,result } = await getUserList({
                    status: 1,
                    pageSize: 20,
                    currentPage: 1,
                    searchCondition: query
                })
                if(code === 0) {
                    this.userList = result.userList
                }
            } catch (error) {
                console.log(error)
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler(newVal) {
                this.initData(newVal)
            }
        },
        show(newVal) {
            this.visible = newVal
        }
    }
}
</script>

<style lang="scss" scoped>
.user-edit-wrap {

    .el-select,
    .el-input,
    .el-textarea,
    .el-cascader {
        width: 300px;
    }
    .el-input-group__append {
        .el-select {
            width: 150px;
        }
    }
}
</style>
